import { ReactNode, useMemo } from 'react';
import ModalContext from './ModalContext';

interface ModalContextProviderProps {
  children: ReactNode;
  modalId: string;
}

const ModalContextProvider = ({
  children,
  modalId,
}: ModalContextProviderProps) => {
  const contextValue = useMemo(
    () => ({
      modalId,
    }),
    [modalId],
  );

  return (
    <ModalContext.Provider value={contextValue}>
      {children}
    </ModalContext.Provider>
  );
};

export default ModalContextProvider;
